import { render, staticRenderFns } from "./user-search-book-ratio.vue?vue&type=template&id=c61862c0&"
import script from "./user-search-book-ratio.vue?vue&type=script&lang=js&"
export * from "./user-search-book-ratio.vue?vue&type=script&lang=js&"
import style0 from "./user-search-book-ratio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports